import { defineMessages } from 'react-intl';

const scope = 'app.widgets.BusinessAnalysis.mainView';

export default defineMessages({
    viewDetailsBtn: {
        id: `${scope}.button.viewDetails`,
        defaultMessage: 'Detailed View',
    },
});
